"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.decomposeIconName = void 0;
const decomposeIconName = (name) => {
    const splittedIcon = name.split('-');
    const icon = splittedIcon.reduce((prev, current) => prev + (0, exports.capitalize)(current), "");
    return { type: splittedIcon[0], icon: icon };
};
exports.decomposeIconName = decomposeIconName;
const capitalize = (str) => (str.charAt(0).toUpperCase() + str.slice(1));
exports.capitalize = capitalize;
//# sourceMappingURL=utils.js.map